<template>
  <v-app>
    <Navbar toolbarColor="white" />

    <slot name="sidenav">
      <side-navbar
        v-if="$vuetify.breakpoint.mdAndDown && showSidenav"
        @toggleSidenav="showSidenav = !showSidenav" />
    </slot>

    <v-main>
      <router-view />
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
import Navbar from '@/modules/shared/components/ui/Navbar'
import Footer from '@/modules/shared/components/ui/Footer'
import SideNavbar from '@/modules/shared/components/ui/SideNavbar'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Footer,
    SideNavbar,
  },
  data: () => ({
    showSidenav: false,
  }),
}
</script>

<style scoped lang="scss">
main, .v-main {
  background-color: $backGrey;
}

::v-deep {
  .v-main__wrap {
    padding-top: 100px;
  }
}
</style>
